import { render } from "./EmployeeHome.vue?vue&type=template&id=6bf540bc"
import script from "./EmployeeHome.vue?vue&type=script&lang=js"
export * from "./EmployeeHome.vue?vue&type=script&lang=js"

import "./EmployeeHome.vue?vue&type=style&index=0&id=6bf540bc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__